import EmployeeTable from "./employeeTable.container";

export default EmployeeTable;